/* eslint-disable prettier/prettier */
/* eslint-disable no-nested-ternary */
// import { faShare } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Activity, FileText, Info, User } from "react-feather";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import styled from "styled-components";
import { Activities } from "../../components/Activities";
import Filemanager from "../../components/FileManager";
import DetalleNP from "./detail";
import ContactNP from "./contact";

const TabsContainer = styled.div`
  .activo {
    color: #f0292a !important;
    border-bottom: 2px solid #f0292a !important;
  }
  .nav-link:hover {
    color: #f0292a !important;
    font-family: "Nunito" !important;
  }
`;

const Tabs = ({ activityComponent, id, entity, disabled, nota, editNotaForm, setEditNotaForm, handleEditData, reloadFiles, categories }) => {
  const [activeTab, setActiveTab] = useState("1");
  const handleFilesChange = () => {
    activityComponent.current.refreshActivities();
  };

  return (
    <>
      <TabsContainer>
        <Nav tabs className="border-tab nav-primary mb-2" style={{ justifyContent: "space-evenly" }}>
          <NavItem className="nav nav-tabs" role="tablist">
            <NavLink className={`${activeTab === "1" ? "activo" : ""} px-2 nav-link`} style={{ display: "grid", cursor: "pointer" }} onClick={() => setActiveTab("1")}>
              <span>
                <Info />
              </span>
              <small style={{ fontSize: "11px" }}>Info </small>
            </NavLink>
          </NavItem>
          <NavItem className="nav nav-tabs" role="tablist">
            <NavLink className={`${activeTab === "2" ? "activo" : ""} px-2 nav-link`} style={{ display: "grid", cursor: "pointer" }} onClick={() => setActiveTab("2")}>
              <span>
                <Activity />
              </span>
              <small style={{ fontSize: "11px" }}>Actividad </small>
            </NavLink>
          </NavItem>
          <NavItem className="nav nav-tabs" role="tablist">
            <NavLink className={`${activeTab === "3" ? "activo" : ""} px-2 nav-link`} style={{ display: "grid", cursor: "pointer" }} onClick={() => setActiveTab("3")}>
              <span>
                <User />
              </span>
              <small style={{ fontSize: "11px" }}>Contacto</small>
            </NavLink>
          </NavItem>
          <NavItem className="nav nav-tabs" role="tablist">
            <NavLink className={`${activeTab === "4" ? "activo" : ""} px-2 nav-link`} style={{ display: "grid", cursor: "pointer" }} onClick={() => setActiveTab("4")}>
              <span>
                <FileText />
              </span>
              <small style={{ fontSize: "11px" }}>Archivos</small>
            </NavLink>
          </NavItem>
        </Nav>
      </TabsContainer>
      <TabContent activeTab={activeTab} className="p-0">
        <TabPane tabId="1" className="p-2">
          <DetalleNP
            nota={nota}
            editNotaForm={editNotaForm}
            setEditNotaForm={setEditNotaForm}
            handleEditData={handleEditData}
            anularCancelar={disabled}
            categories={categories}
          />
        </TabPane>
        <TabPane tabId="2" className="p-2">
          <Activities
            ref={activityComponent}
            bodyStyle={{ overflow: "auto scroll", paddingLeft: "10px", paddingRight: "10px", paddingTop: "10px", maxHeight: "910px" }}
            entityId={id}
            entity={entity}
            editable={!disabled}
            hideHeader
          />
        </TabPane>
        <TabPane tabId="3" className="p-2">
          <ContactNP nota={nota} editNotaForm={editNotaForm} setEditNotaForm={setEditNotaForm} handleEditData={handleEditData} anularCancelar={disabled} />
        </TabPane>
        <TabPane tabId="4" className="p-2">
          <Filemanager
            bodyStyle={{ overflow: "auto", paddingLeft: "10px", paddingRight: "10px", paddingTop: "10px" }}
            fileNameStyle={{ fontSize: "14px", fontWeight: "500", fontFamily: "Nunito", color: "#293134" }}
            entityId={id}
            entity={entity}
            onChange={handleFilesChange}
            editable={!disabled}
            hideHeader
            reloadFiles={reloadFiles}
            fileIconStyle={{ width: "20px", margin: "15px 15px 15px 0", color: "#f0292a" }}
            NP
          />
        </TabPane>
      </TabContent>
    </>
  );
};

export default Tabs;
